import { ChangeDetectorRef, Component } from '@angular/core';

import { Keepalive } from '@ng-idle/keepalive';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

import { environment } from '@environments/environment';
import Resources from './core/constants/resourses';

import { SessionService } from './core/services/session.service';
import { UtilityService } from '@services/utility.service';
import { EnvironmentAuthService } from '@services/environment-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  idleState = "NOT_STARTED";
  countdown?: number = null;
  lastPing?: Date = null;
  ipAddress: any;
  
  isAuthenticated: boolean = false;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private cd: ChangeDetectorRef,
    private utility: UtilityService,
    private sessionService: SessionService,
    private envAuthService: EnvironmentAuthService
  ) {
    // set idle parameters
    idle.setIdle(3600); // will consider idle state start after given seconds. i.e 5 seconds
    idle.setTimeout(10); // After idle state started, countdown for given seconds to timeout. 
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active

    // On Idle state starting
    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'IDLE';
    });

    // On Idle state ended
    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = "NOT_IDLE";
      this.countdown = null;
      cd.detectChanges(); // how do i avoid this kludge?
    });

    //
    this.idle.onTimeout.subscribe(() => {
      this.idleState = "TIMED_OUT";
      this.sessionService.clearData();
      this.sessionService.clearLocalStorage();
      this.sessionService.clearSessionStorage();
      window.open(environment.home_url, '_self');
    });

    // do something as the timeout countdown does its thing
    this.idle.onTimeoutWarning.subscribe(seconds => {
      this.countdown = seconds;
    });

    // set keepalive parameters, omit if not using keepalive
    keepalive.interval(10); // will ping at this interval while not idle, in seconds
    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
    });

    // Cleanup: Remove obsolete AB testing cookies from previous implementation
    // These cookies are no longer used and should be deleted
    this.utility.deleteCookie('landing_page_variant');
    this.utility.deleteCookie('ctm_flow_variant');
  }

  ngOnInit(): void {
    // If requires auth and not authenticated, show dialog
    if (this.envAuthService.requiresAuth()) {
      this.showAuthDialog();
    } else {
      this.isAuthenticated = true;
      this.initializeApp();
    }
  }

  // Show authentication dialog
  async showAuthDialog(): Promise<void> {
    const authenticated = await this.envAuthService.showAuthDialog();
    if (authenticated) {
      this.isAuthenticated = true;
      this.initializeApp();
    }
  }

  // Initialize app after authentication
  initializeApp(): void {
    this.utility.getIPAddress().subscribe({
      next: (res) => {
        this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.IpAddress, res?.ip);
      }, error: (err) => {
        console.log('Error while fetching IP address', err);
      }
    });

    // Reset the idle process
    this.reset();
  }

  reset() {
    // we'll call this method when we want to start/reset the idle process
    // reset any component state and be sure to call idle.watch()
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }
}
